import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import useDataStore from "../../store/useDataStore";
import useWidgetStore from "../../store/useWidgetStore";
import { useSettings } from "../../context/SettingsContext";
export const useCreateMandate = (formContext, options) => {
    const { api_key, widget_id } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    const { cart, consumer, } = useWidgetStore();
    const { apptypes, } = useDataStore();
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-createMandate'], queryFn: async ({ signal }) => {
            var _a, _b;
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'createMandate', 'checkout');
            let data = {
                customerId: (_a = consumer.id) !== null && _a !== void 0 ? _a : '',
                order_id: (_b = cart.order_id) !== null && _b !== void 0 ? _b : '',
                mandateId: formContext.getValues('mandateId'),
                mandate: formContext.getValues('mandate'),
                membershipTypeId: formContext.getValues('membershipTypeId')
            };
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST",
                headers: {
                    'Content-Type': 'application/json', // checks this header if it's a POST, while calling the method getRestData.... That's not Restful
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/json+ld',
                },
                body: JSON.stringify(data)
            });
            return response.json();
        } }));
};
